import { request } from "common/components/request";
import { store } from "common/store";

export const FETCH_SUMMARY_DATA = function({ url, start, end, q }) {
    const state = store.getState();
    return request(url, {
        data: {
            currency: state.common.currency,
            start,
            end,
            page: 1,
            q: q.toString(true)
        }
    });
};
